import { css } from '@emotion/react'
import { Stack, Typography } from '@nexans/react-ui-kit'

type LinearProgressBarProps = {
  progress: number
  startLabel: string
  endLabel: string
}

function LinearProgressBar({ progress, startLabel, endLabel }: LinearProgressBarProps) {
  const clampedProgress = Math.min(100, Math.max(0, progress))

  return (
    <Stack spacing="xs" fullWidth>
      <Stack direction="horizontal" justify="space-between">
        <Typography variant="caption">{startLabel}</Typography>
        <Typography variant="caption">{endLabel}</Typography>
      </Stack>
      <div css={styles.container}>
        <div css={[styles.progress, { width: `${clampedProgress}%` }]} />
      </div>
    </Stack>
  )
}

const styles = {
  container: css({
    width: '100%',
    height: 11,
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: '#D9D9D9',
  }),
  progress: css({
    height: '100%',
    borderRadius: 8,
    background: 'linear-gradient(90deg, #EF3D37 0%, #ED8A87 100%)',
    transition: 'width 0.3s ease-in-out',
  }),
}

export default LinearProgressBar
